import * as actionTypes from '../actions/actionTypes';
import deviceInfo from '../util/DeviceInfoUtil';
import uuid from 'uuid';

const initialExperiencesData = {
  agentAssignStatus: true,
  assignedAgentName: 'VHT',
  channel: null,
  customerNewDeviceModel: null,
  customerOldDeviceModel: null,
  endpointId: null,
  messageId: window.messageId,
  programId: null,
  repBrowserInfo: null,
  repDeviceInfo: null,
  sourceDomain: null,
  storeLocation: 'DestinationSite',
  storeName: 'DestinationSite',
  universalId: null, // TODO: need call atlas api to get it
  vhtSegmentId: null,
  vhtclientCode: 'ATT_MPC', // This is the code for MUC
  ...deviceInfo,
  customerSessionId: uuid.v1(), // TODO: should this change between different experience booking ?
  distinctId: uuid.v1(), // TODO: should this change between different experience booking ?

  experienceBookingSuccess: null,
  experienceBookingInProgress: false,
  experienceBookingModal: null,

  appointmentData: {
    customerFirstName: '',
    customerLastName: '',
    customerCallbackNumber: '',
    customerEmailAddress: '',
    timezone: 'choose',
    captchaResponse: '',
    customerAppointmentDateTime: null,
    customerAppointmentDateTimeString: '',
  },
};

export default function experiencesReducer(state = initialExperiencesData, action) {
  switch (action.type) {
    case actionTypes.SET_AVAILABLE_CALL_MODES:
      return {
        ...state,
        availableCallModes,
      };
    case actionTypes.SET_ONBOARDING_ANSWERS:
      return {
        ...state,
        onboardingAnswers: action.onboardingAnswers,
      };
    case actionTypes.SET_SELECTED_CALL_MODE:
      return {
        ...state,
        selectedCallMode,
      };
    case actionTypes.SET_EXPERIENCES_LIST:
      return {
        ...state,
        experiencesList: action.experiencesList,
      };
    case actionTypes.SET_EXPERIENCE_SELECTED:
      return {
        ...state,
        experienceSelected: action.experienceSelected,
      };
    case actionTypes.SET_EXPERIENCE_BOOKING_MODAL:
      return {
        ...state,
        experienceBookingModal: action.experienceBookingModal,
      };
    case actionTypes.SET_EXPERIENCE_BOOKING_SUCCESS:
      return {
        ...state,
        experienceBookingSuccess: action.experienceBookingSuccess,
      };
    case actionTypes.SET_EXPERIENCE_BOOKING_IN_PROGRESS:
      return {
        ...state,
        experienceBookingInProgress: action.experienceBookingInProgress,
      };
    case actionTypes.SET_CHANNEL:
      return {
        ...state,
        channel: action.channel,
      };
    case actionTypes.SET_VHT_SEGMENT:
      return {
        ...state,
        vhtSegment: action.vhtSegment,
      };
    case action.SET_ATLAS_ID:
      return {
        ...state,
        atlastId: action.atlastId,
      };
    case actionTypes.SET_CUSTOMER_FIRST_NAME:
      return {
        ...state,
        customerFirstName: action.customerFirstName,
      };
    case actionTypes.SET_CUSTOMER_LAST_NAME:
      return {
        ...state,
        customerLastName: action.customerLastName,
      };
    case actionTypes.SET_CUSTOMER_CALLBACK_NUMBER:
      return {
        ...state,
        customerCallbackNumber: action.customerCallbackNumber,
      };
    case actionTypes.SET_CUSTOMER_EMAIL_ADDRESS:
      return {
        ...state,
        customerEmailAddress: action.customerEmailAddress,
      };
    case actionTypes.SET_CUSTOMER_TIME_ZONE:
      return {
        ...state,
        timezone: action.timezone,
      };
    case actionTypes.SET_APPOINTMENT_DATE_TIME:
      return {
        ...state,
        customerAppointmentDateTime: action.customerAppointmentDateTime,
      };
    case actionTypes.SET_CAPTCHA_RESPONSE:
      return {
        ...state,
        captchaResponse: action.captchaResponse,
      };
    case actionTypes.SET_APPOINTMENT_DATA:
      return {
        ...state,
        appointmentData: action.appointmentData,
      };
    case actionTypes.GET_NEW_CUSTOMER_SESSION_ID:
      return {
        ...state,
        customerSessionId: action.customerSessionId,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/reducers/Experiences.js